<template>
  <svg
    fill="none"
    height="1507"
    viewBox="0 0 550 1507"
    width="550"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      width="80"
      x="504"
      y="1427"
    />
    <rect
      fill="#F9FBFC"
      height="80"
      rx="8"
      transform="rotate(180 80 1423)"
      width="80"
      x="80"
      y="1423"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="rotate(180 80 1003)"
      width="80"
      x="80"
      y="1003"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="rotate(180 80 919)"
      width="80"
      x="80"
      y="919"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="rotate(180 80 835)"
      width="80"
      x="80"
      y="835"
    />
    <rect
      fill="#F9FBFC"
      height="80"
      rx="8"
      transform="rotate(180 80 751)"
      width="80"
      x="80"
      y="751"
    />
    <rect
      fill="#F9FAFC"
      height="80"
      rx="8"
      transform="rotate(180 164 1423)"
      width="80"
      x="164"
      y="1423"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="rotate(180 164 1339)"
      width="80"
      x="164"
      y="1339"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="rotate(180 164 1255)"
      width="80"
      x="164"
      y="1255"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="rotate(180 164 919)"
      width="80"
      x="164"
      y="919"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="rotate(180 164 835)"
      width="80"
      x="164"
      y="835"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="rotate(180 164 751)"
      width="80"
      x="164"
      y="751"
    />
    <rect
      fill="#F9FAFB"
      height="80"
      rx="8"
      transform="rotate(180 164 667)"
      width="80"
      x="164"
      y="667"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="rotate(180 248 1423)"
      width="80"
      x="248"
      y="1423"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="rotate(180 248 919)"
      width="80"
      x="248"
      y="919"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="rotate(180 248 835)"
      width="80"
      x="248"
      y="835"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="rotate(180 248 751)"
      width="80"
      x="248"
      y="751"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="rotate(180 248 667)"
      width="80"
      x="248"
      y="667"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="rotate(180 332 1423)"
      width="80"
      x="332"
      y="1423"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="rotate(180 332 1339)"
      width="80"
      x="332"
      y="1339"
    />
    <rect
      fill="#F6F8F8"
      height="80"
      rx="8"
      transform="rotate(180 332 1003)"
      width="80"
      x="332"
      y="1003"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="rotate(180 332 919)"
      width="80"
      x="332"
      y="919"
    />
    <rect
      fill="#F1F5F9"
      height="80"
      rx="8"
      transform="rotate(180 332 835)"
      width="80"
      x="332"
      y="835"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="rotate(180 332 751)"
      width="80"
      x="332"
      y="751"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="rotate(180 332 667)"
      width="80"
      x="332"
      y="667"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="rotate(180 416 1423)"
      width="80"
      x="416"
      y="1423"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="rotate(180 416 1339)"
      width="80"
      x="416"
      y="1339"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="rotate(180 416 1255)"
      width="80"
      x="416"
      y="1255"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="rotate(180 416 1003)"
      width="80"
      x="416"
      y="1003"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="rotate(180 416 919)"
      width="80"
      x="416"
      y="919"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="rotate(180 416 835)"
      width="80"
      x="416"
      y="835"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="rotate(180 416 751)"
      width="80"
      x="416"
      y="751"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="rotate(180 416 667)"
      width="80"
      x="416"
      y="667"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="rotate(180 500 1423)"
      width="80"
      x="500"
      y="1423"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="rotate(180 500 1339)"
      width="80"
      x="500"
      y="1339"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="rotate(180 500 1255)"
      width="80"
      x="500"
      y="1255"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="rotate(180 500 1087)"
      width="80"
      x="500"
      y="1087"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="rotate(180 500 1003)"
      width="80"
      x="500"
      y="1003"
    />
    <rect
      fill="#EBEDF5"
      height="80"
      rx="8"
      transform="rotate(180 500 919)"
      width="80"
      x="500"
      y="919"
    />
    <rect
      fill="#F6F8F9"
      height="80"
      rx="8"
      transform="rotate(180 500 835)"
      width="80"
      x="500"
      y="835"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="rotate(180 500 751)"
      width="80"
      x="500"
      y="751"
    />
    <rect
      fill="#F4F6F8"
      height="80"
      rx="8"
      transform="rotate(180 500 667)"
      width="80"
      x="500"
      y="667"
    />
    <rect
      fill="#F4F6F8"
      height="80"
      rx="8"
      transform="rotate(180 584 1423)"
      width="80"
      x="584"
      y="1423"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="rotate(180 584 1339)"
      width="80"
      x="584"
      y="1339"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="rotate(180 584 1255)"
      width="80"
      x="584"
      y="1255"
    />
    <rect
      fill="#EBEDF5"
      height="80"
      rx="8"
      transform="rotate(180 584 1171)"
      width="80"
      x="584"
      y="1171"
    />
    <rect
      fill="#F4F6F8"
      height="80"
      rx="8"
      transform="rotate(180 584 1087)"
      width="80"
      x="584"
      y="1087"
    />
    <rect
      fill="#F4F6F8"
      height="80"
      rx="8"
      transform="rotate(180 584 1003)"
      width="80"
      x="584"
      y="1003"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="rotate(180 584 919)"
      width="80"
      x="584"
      y="919"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="rotate(180 584 835)"
      width="80"
      x="584"
      y="835"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="rotate(180 584 751)"
      width="80"
      x="584"
      y="751"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="rotate(180 584 667)"
      width="80"
      x="584"
      y="667"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 584 84)"
      width="80"
    />
    <rect
      fill="#EBEDF5"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 584 168)"
      width="80"
    />
    <rect
      fill="#F4F6F8"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 584 252)"
      width="80"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 584 420)"
      width="80"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 584 504)"
      width="80"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 584 588)"
      width="80"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 500 168)"
      width="80"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 500 252)"
      width="80"
    />
    <rect
      fill="#F6F8F9"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 500 504)"
      width="80"
    />
    <rect
      fill="#F2F5F9"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 416 168)"
      width="80"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 416 504)"
      width="80"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 416 588)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 416 672)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 332 0)"
      width="80"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 332 252)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 332 588)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 332 672)"
      width="80"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 332 672)"
      width="80"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      rx="8"
      transform="matrix(-1 0 0 1 248 672)"
      width="80"
    />
  </svg>
</template>

<script>
export default {
  name: 'NlpRightBackground',
}
</script>